'use client'
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useContainerBreakpoints } from "../../hooks/index.js";
const ResponsiveContext = /*#__PURE__*/ createContext(null);
function ResponsiveWrapper({ children }) {
    const { containerRef, ...breakpoints } = useContainerBreakpoints();
    return /*#__PURE__*/ jsx(ResponsiveContext.Provider, {
        value: breakpoints,
        children: /*#__PURE__*/ jsx("div", {
            ref: containerRef,
            className: "@container",
            children: children
        })
    });
}
function useResponsive() {
    const ctx = useContext(ResponsiveContext);
    if (!ctx) throw new Error('useResponsive must be used within a ResponsiveWrapper');
    return ctx;
}
const Responsive = {
    Provider: ResponsiveWrapper,
    useResponsive
};
export { Responsive, ResponsiveWrapper, useResponsive };
